import React from 'react';
import { useRecoilState } from 'recoil';

import useTeeshotApiRequest from './use-teeshotApiRequest';
import { settingState } from '../recoil/settingState';
import { Suspense, useEffect } from 'react';

export default function useSetting() {
    const [settingStateData, setSettingStateData] =
        useRecoilState(settingState);
    useEffect(() => {
        // 항상 false로 시작 (가이드 모달을 무조건 off로 설정)
        setSettingStateData({
            guide: false,
        });
        // 로컬스토리지도 false로 설정
        localStorage.setItem('guide-checked', 'false');
    }, []);

    useEffect(() => {
        if (
            settingStateData.guide === true ||
            settingStateData.guide === false
        ) {
            localStorage.setItem('guide-checked', settingStateData.guide);
        }
    }, [settingStateData.guide]);
}
